import React, { useEffect, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import "./simulator.scss";
import { Row, Col, InputGroup, Form } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";
import HelperService from "../../Services/HelperService";
import Loader from "../../components/Loader/Loader";
import SimulatorDeleteModal from "../../components/SimulatorDeleteModal/SimulatorDeleteModal";
import { Link, useNavigate, useParams } from "react-router-dom";
import ShareService from "../../Services/ShareService";
import Grid, {
  GridColumn,
  GridHeader,
  GridRow,
} from "../../components/Grid/Grid";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useLocation } from "react-router-dom";

const Simulators = () => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const [FilterObj, setFilterObj] = useState<any>({});
  const [Count, setCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState<any>("");
  const [permissions, setPermissions] = useState({
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
  });
  const [types, setTypes] = useState<any[]>([]);
  const [ruleFilter, setRuleFilter] = useState("");
  const [stageFilter, setStageFilter] = useState("");
  const [airportControlFilter, setAirportControlFilter] = useState("");

  const [activeCourse, setActiveCourse] = useState<any>(null);

  const [allData, setAllData] = useState<any[]>([]);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    typeList();
  }, []);

  //   useEffect(() => {
  //     if (activeType) {
  //       getlist(1, searchKeyword);
  //     }
  //   }, [activeType]);

  const typeList = () => {
    setShowLoader(true);
    const userdFor = "COURSE";
    WebService.getAPI({
      action: `/simulator-courses/list?type=${userdFor}`,
      body: null,
    })
      .then((res: any) => {
        setShowLoader(false);
        const list = res || [];
        setTypes(list);

        if (list.length > 0) {
          setActiveCourse(list[0]);
        }
      })
      .catch((e: any) => {
        setShowLoader(false);
        toast.error(e?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (!activeCourse?.course_id) return;

    getlist(1, searchKeyword);
  }, [activeCourse?.course_id]);

  const getlist = (
    page: any,
    searchText?: any,
    order_by?: any,
    sort_by?: any,
  ) => {
    // alert("caleed");
    setShowLoader(true);
    const obj: any = { ...FilterObj };
    obj.offset = page ? page - 1 : 0;
    obj.keyword = searchText ?? "";
    if (order_by) obj.order_by = order_by;
    if (sort_by) obj.sort_by = sort_by;

    setFilterObj(obj);
    ShareService.setMapValue("listing-levels-filter", obj);

    const queryParams = new URLSearchParams({
      keyword: obj.keyword || "",
      sort_by: obj.sort_by || "ordering",
      order_by: obj.order_by || "asc",
      offset: obj.offset.toString(),
      limit: "50",
      course_id: activeCourse.course_id.toString(),
      ...(ruleFilter && { sim_rule: ruleFilter }),
      ...(stageFilter && { sim_stage: stageFilter }),
      ...(airportControlFilter && { airport_control: airportControlFilter }),
    }).toString();
    console.log("paramsss", queryParams);

    WebService.getAPI({
      action: `/simulator-lesson/list?${queryParams}`,
      body: obj,
    })
      .then((res: any) => {
        setShowLoader(false);
        setCount(res.count);
        setAllData(res.list || []);

        setRows(rows);
      })
      .catch(() => setShowLoader(false));
  };

  const showAccessDenied = () => toast.error("Access Denied");

  const Lessons = (data: any) => (
    <div className="action-btns text-left">
      <Link
        to={`/lessons/${data.uuid}`}
        className="text-blue p-1 me-1 text-bold"
        style={{ textDecoration: "none" }}
      >
        View
      </Link>
    </div>
  );

  const actionList = (data: any, perms: any) => {
    const p = perms ?? permissions;
    return (
      <div className="action-btns text-left">
        {p.can_update ? (
          <a
            href={`/levels/${data.uuid}`}
            className="text-dark p-1 me-1"
            title="Edit"
          >
            <FiEdit size={18} />
          </a>
        ) : (
          ""
        )}
        {p.can_delete ? (
          <button
            className="text-danger btn btn-link p-1"
            title="Delete"
            onClick={() => handleDelete(data.uuid, p)}
          >
            <FiTrash2 size={18} />
          </button>
        ) : (
          ""
        )}
      </div>
    );
  };

  const handleDelete = (id: any, perms?: any) => {
    const p = perms ?? permissions;
    // if (!p?.can_delete) return showAccessDenied();
    setShowModal(true);
    setRequest(id);
  };

  const handleDragEnd = async (result: any) => {
    if (!result.destination) return;

    const filtered = [...filteredList];

    const [moved] = filtered.splice(result.source.index, 1);
    filtered.splice(result.destination.index, 0, moved);

    const newOrder = filtered.map((x, i) => ({
      uuid: x.uuid,
      ordering: i + 1,
    }));

    try {
      await WebService.postAPI({
        action: "/simulator-lesson/reorder",
        body: { order: newOrder },
      });

      toast.success("Order updated successfully");
      getlist(1);
    } catch {
      toast.error("Failed to update order");
    }
  };
  const filteredList = allData
    .filter((l) => l.name?.toLowerCase().includes(searchKeyword.toLowerCase()))
    .sort((a, b) => (a.ordering ?? 0) - (b.ordering ?? 0));

  const headers: GridHeader[] = [
    { title: "Sr No", width: 100, class: "", isSorting: false, sortingKey: "" },
    {
      title: "Date",
      width: 300,
      class: "",
      isSorting: true,
      sortingKey: "created_at",
    },
    {
      title: "Lesson Title",
      width: 300,
      class: "",
      isSorting: true,
      sortingKey: "title",
    },
    {
      title: "Sim Stage",
      isSorting: true,
      sortingKey: "sim_stage",
      width: 300,
    },
    {
      title: "Sim Rule",
      width: 300,
      isSorting: true,
      sortingKey: "sim_rule",
      class: "",
    },
    {
      title: "Sim Airport",
      width: 300,
      isSorting: true,
      sortingKey: "sim_airport_code",
      class: "",
    },
  ];
  useEffect(() => {
    if (!activeCourse?.course_id) return;

    getlist(1, searchKeyword);
  }, [ruleFilter, stageFilter, airportControlFilter, activeCourse?.course_id]);
  const Questions = (lesson: any) => {
    const lessonUuid = lesson.uuid;
    const isTemplateChild = !!lesson.is_template_child;
    const templateUuid = lesson.template_lesson_uuid;

    const smallBtnStyle: React.CSSProperties = {
      padding: "2px 8px",
      fontSize: "12px",
      lineHeight: 1.2,
    };

    const btn = (label: string, href: string, cls: string) => (
      <a
        href={href}
        className={`btn btn-sm ${cls} me-1`}
        style={smallBtnStyle}
        title={label}
      >
        {label}
      </a>
    );

    if (isTemplateChild) {
      const sharedActive = lesson.shared_active_lesson_questions_version_id;
      const sharedDraft = lesson.shared_draft_lesson_questions_version_id;
      const version = sharedActive ? "published" : sharedDraft ? "draft" : null;
      const hasAny = sharedActive || sharedDraft;
      return (
        <div className="d-flex align-items-center flex-wrap gap-1">
          <span
            className="badge bg-light text-dark border"
            style={{ fontWeight: 500 }}
          >
            Uses shared template
          </span>
          {hasAny && templateUuid ? (
            <a
              href={`/questions?uuid=${templateUuid}&version=${version}&source=simulator`}
              className="text-decoration-none ms-1"
              style={{ fontSize: 12 }}
              title="Open shared template"
            >
              View source
            </a>
          ) : (
            <span className="text-muted ms-1" style={{ fontSize: 12 }}>
              (not configured yet)
            </span>
          )}
        </div>
      );
    }

    const activeId = lesson.active_lesson_questions_version_id;
    const draftId = lesson.draft_lesson_questions_version_id;

    return (
      <div className="d-flex align-items-center flex-wrap gap-1">
        {activeId
          ? btn(
              "View Published Version",
              `/questions?uuid=${lessonUuid}&version=published&source=simulator`,
              "btn-success",
            )
          : null}
        {draftId
          ? btn(
              "View Drafted Version",
              `/questions?uuid=${lessonUuid}&version=draft&source=simulator`,
              "btn-warning text-dark",
            )
          : null}
        {!activeId && !draftId
          ? btn(
              "Add Question",
              `/questions?uuid=${lessonUuid}&version=draft&source=simulator`,
              "btn-primary",
            )
          : null}
      </div>
    );
  };
  return (
    <div className="dashboard-content">
      <Row className="mb-3 align-items-center justify-content-between">
        <Col lg={2}>
          <h1 className="font-20 font-bold mb-0">Manage Simulators</h1>
        </Col>
        <Col lg={2} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <Form.Select
              value={ruleFilter}
              onChange={(e) => setRuleFilter(e.target.value)}
            >
              <option value="">All Rules</option>
              <option value="IFR">IFR</option>
              <option value="VFR">VFR</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col lg={2} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <Form.Select
              value={stageFilter}
              onChange={(e) => setStageFilter(e.target.value)}
            >
              <option value="">All Stages</option>
              <option value="ARRIVAL">Arrival</option>
              <option value="DEPARTURE">Departure</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col lg={2} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <Form.Select
              value={airportControlFilter}
              onChange={(e) => setAirportControlFilter(e.target.value)}
            >
              <option value="">All Types</option>
              <option value="CONTROLLED">Controlled</option>
              <option value="UNCONTROLLED">Uncontrolled</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col lg={2} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <InputGroup.Text>
              <IoSearchOutline size={18} />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search..."
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyUp={(e) => getlist(1, e.currentTarget.value)}
            />
          </InputGroup>
        </Col>
        <Col lg={2}>
          {/* {permissions.can_create ? ( */}
          {activeCourse && (
            <Link
              to={`/simulator-lesson/${activeCourse.course_level_uuid}/add`}
              className="text-decoration-none"
            >
              <button className="btn btn-brand-1 d-block mx-auto">
                + Simulator
              </button>
            </Link>
          )}
        </Col>
      </Row>

      {/* ✅ Tabs for VFR / IFR */}

      <div className="tab-toggle-group mb-3 mt-3">
        <div className="btn-group" role="group">
          {types.map((c) => (
            <button
              type="button"
              key={c.id}
              className={`tab-btn ${
                activeCourse?.course_id === c.course_id ? "active" : ""
              }`}
              onClick={() => setActiveCourse(c)}
            >
              {c.type}
            </button>
          ))}
        </div>
      </div>

      <Loader show={ShowLoader} />

      {/* ✅ Drag & Drop Table */}
      <div className="p-2 card">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ width: "60px" }}>#</th>
              <th>Date</th>
              <th>Simulator Name</th>
              <th>Sim Stage</th>
              {/* <th>Sim Rule</th> */}
              <th>Sim Airport</th>
              <th>Type</th>
              <th>Questions</th>
              <th>Action</th>
            </tr>
          </thead>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="levels">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {ShowLoader ? null : filteredList.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center py-4 text-muted">
                        No Records Found
                      </td>
                    </tr>
                  ) : (
                    filteredList.map((item, index) => (
                      <Draggable
                        key={item.uuid}
                        draggableId={item.uuid}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={`${
                              snapshot.isDragging ? "table-active" : ""
                            }`}
                            style={{
                              ...provided.draggableProps.style,
                              cursor: "grab",
                            }}
                          >
                            <td>{index + 1}</td>
                            <td>
                              {HelperService.getFormatedDate(item.created_at)}
                            </td>
                            <td className="fw-semibold">{item.name}</td>
                            <td className="fw-semibold">
                              {HelperService.getTitleCase(item.sim_stage)}
                            </td>
                            {/* <td className="fw-semibold">{item.sim_rule}</td> */}
                            <td className="fw-semibold">
                              {item.airports ? item.airports.name : "*"}
                            </td>
                            <td className="fw-semibold">
                              {item.airports?.control_air_fields
                                ? HelperService.getTitleCase(
                                    item.airports.control_air_fields,
                                  )
                                : "*"}
                            </td>
                            <td>{Questions(item)}</td>
                            <td>
                              <div className="d-flex gap-2 align-items-center">
                                <button
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={() =>
                                    navigate(
                                      `/simulator-lesson/${activeCourse.course_level_uuid}/${item.uuid}
                                      `,
                                    )
                                  }
                                >
                                  <FiEdit />
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDelete(item.uuid)}
                                >
                                  <FiTrash2 />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>

      {showModal && (
        <SimulatorDeleteModal
          id={request}
          title="Are you sure you want to delete!"
          showModal={showModal}
          onCloseModel={() => {
            setShowModal(false);
            getlist(1, searchKeyword);
          }}
        />
      )}
    </div>
  );
};

export default Simulators;
